// extracted by css-extract-rspack-plugin
export default {"passwordSetSubtitle":"SetPassword_passwordSetSubtitle__w-+xD"};